var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2543 6.125H20.1293V14.875H19.2543V17.5C19.2543 17.9833 18.8626 18.375 18.3793 18.375H2.62927C2.14603 18.375 1.75427 17.9833 1.75427 17.5V3.5C1.75427 3.01675 2.14603 2.625 2.62927 2.625H18.3793C18.8626 2.625 19.2543 3.01675 19.2543 3.5V6.125ZM17.5043 14.875H12.2543C9.83807 14.875 7.87927 12.9162 7.87927 10.5C7.87927 8.08376 9.83807 6.125 12.2543 6.125H17.5043V4.375H3.50427V16.625H17.5043V14.875ZM18.3793 13.125V7.875H12.2543C10.8045 7.875 9.62929 9.05021 9.62929 10.5C9.62929 11.9498 10.8045 13.125 12.2543 13.125H18.3793ZM12.2543 9.625H14.8793V11.375H12.2543V9.625Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.1b9b9745f653c4a57ec0511287489ba3.svg";
export { ForwardRef as ReactComponent };